import React, { useState } from "react";

export default function SettingsModal({
  open,
  onClose,
  editMode,
  setEditMode,
  isLoadingProfile,
  editFirstName,
  setEditFirstName,
  editLastName,
  setEditLastName,
  editEmail,
  setEditEmail,
  editAddress,
  setEditAddress,
  editCity,
  setEditCity,
  editCountry,
  setEditCountry,
  editPhone,
  setEditPhone,
  editPostcode,
  setEditPostcode,
  notifEnabled,
  setNotifEnabled,
  handleSaveSettings,
  changePasswordCurrentPassword,
  setChangePasswordCurrentPassword,
  changePasswordNewPassword,
  setChangePasswordNewPassword,
  changePasswordConfirmPassword,
  setChangePasswordConfirmPassword,
  handleChangePassword,
  changePasswordError,
  changePasswordSuccess
}) {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <div onClick={handleBackdropClick} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, minWidth: 340, maxWidth: 400, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 4px 24px #0003', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888', zIndex: 10 }}>&times;</button>
        <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Settings</h3>
        
        {isLoadingProfile && (
          <div style={{ background: '#e3f2fd', color: '#1565c0', padding: 12, borderRadius: 8, marginBottom: 12, fontSize: 14, textAlign: 'center', fontWeight: 500 }}>
            ⏳ Loading profile data...
          </div>
        )}
        
        <form onSubmit={(e) => {
          e.preventDefault();
          setIsSaving(true);
          handleSaveSettings(e);
          setTimeout(() => setIsSaving(false), 1000);
        }} style={{ opacity: isLoadingProfile ? 0.6 : 1, pointerEvents: isLoadingProfile ? 'none' : 'auto' }}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontWeight: 600 }}>First Name:</label>
            <input type="text" value={editFirstName} onChange={e => setEditFirstName(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
            <label style={{ fontWeight: 600 }}>Last Name:</label>
            <input type="text" value={editLastName} onChange={e => setEditLastName(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
            <label style={{ fontWeight: 600 }}>Address:</label>
            <input type="text" value={editAddress} onChange={e => setEditAddress(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} placeholder="Street address" />
            <label style={{ fontWeight: 600 }}>Town/City:</label>
            <input type="text" value={editCity} onChange={e => setEditCity(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
            <label style={{ fontWeight: 600 }}>Country:</label>
            <select value={editCountry} onChange={e => setEditCountry(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 16 }} required>
              <option value="">Select Country</option>
              <option value="United Kingdom">🇬🇧 United Kingdom (+44)</option>
              <option value="United States">🇺🇸 United States (+1)</option>
              <option value="Nigeria">🇳🇬 Nigeria (+234)</option>
              <option value="Canada">🇨🇦 Canada (+1)</option>
              <option value="Germany">🇩🇪 Germany (+49)</option>
              <option value="France">🇫🇷 France (+33)</option>
              <option value="India">🇮🇳 India (+91)</option>
              <option value="South Africa">🇿🇦 South Africa (+27)</option>
              <option value="Other">🌍 Other</option>
            </select>
            <label style={{ fontWeight: 600 }}>Phone Number:</label>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ marginRight: 8, fontSize: 18 }}>
                {editCountry === 'United Kingdom' && '🇬🇧 +44'}
                {editCountry === 'United States' && '🇺🇸 +1'}
                {editCountry === 'Nigeria' && '🇳🇬 +234'}
                {editCountry === 'Canada' && '🇨🇦 +1'}
                {editCountry === 'Germany' && '🇩🇪 +49'}
                {editCountry === 'France' && '🇫🇷 +33'}
                {editCountry === 'India' && '🇮🇳 +91'}
                {editCountry === 'South Africa' && '🇿🇦 +27'}
                {editCountry === 'Other' && '🌍'}
              </span>
              <input type="tel" value={editPhone} onChange={e => setEditPhone(e.target.value)} style={{ flex: 1, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} placeholder="Phone number" required />
            </div>
            <label style={{ fontWeight: 600 }}>Zip/Postcode:</label>
            <input type="text" value={editPostcode} onChange={e => setEditPostcode(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
            <label style={{ fontWeight: 600 }}>Email:</label>
            <input type="email" value={editEmail} onChange={e => setEditEmail(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontWeight: 600, marginRight: 8 }}>Notifications:</label>
            <input type="checkbox" checked={notifEnabled} onChange={e => { setNotifEnabled(e.target.checked); }} />
            <span style={{ marginLeft: 6 }}>{notifEnabled ? 'Enabled' : 'Disabled'}</span>
          </div>
          <button type="submit" disabled={isSaving} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: isSaving ? 'not-allowed' : 'pointer', opacity: isSaving ? 0.7 : 1 }}>{isSaving ? 'Saving...' : 'Save Changes'}</button>
        </form>
        {/* Password Change Section */}
        <div style={{ marginTop: 24, marginBottom: 12, padding: 12, background: '#f7f8fa', borderRadius: 8 }}>
          <h4 style={{ fontWeight: 700, fontSize: 17, marginBottom: 8 }}>Change Password</h4>
          {changePasswordError && <div style={{ background: '#fee', color: '#c33', padding: 8, borderRadius: 6, marginBottom: 8, fontSize: 14 }}>{changePasswordError}</div>}
          {changePasswordSuccess && <div style={{ background: '#efe', color: '#3c3', padding: 8, borderRadius: 6, marginBottom: 8, fontSize: 14 }}>{changePasswordSuccess}</div>}
          <form onSubmit={(e) => {
            e.preventDefault();
            setIsChangingPassword(true);
            handleChangePassword(e);
            setTimeout(() => setIsChangingPassword(false), 2000);
          }}>
            <label style={{ fontWeight: 600 }}>Current Password:</label>
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <input type={showCurrentPassword ? "text" : "password"} value={changePasswordCurrentPassword} onChange={e => setChangePasswordCurrentPassword(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} placeholder="Current password" />
              <button type="button" style={{ position: 'absolute', right: 8, top: 8, background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontWeight: 600 }} onClick={() => setShowCurrentPassword(v => !v)}>{showCurrentPassword ? "Hide" : "Show"}</button>
            </div>
            <label style={{ fontWeight: 600 }}>New Password:</label>
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <input type={showNewPassword ? "text" : "password"} value={changePasswordNewPassword} onChange={e => setChangePasswordNewPassword(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} placeholder="New password" />
              <button type="button" style={{ position: 'absolute', right: 8, top: 8, background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontWeight: 600 }} onClick={() => setShowNewPassword(v => !v)}>{showNewPassword ? "Hide" : "Show"}</button>
            </div>
            <label style={{ fontWeight: 600 }}>Confirm New Password:</label>
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <input type={showConfirmPassword ? "text" : "password"} value={changePasswordConfirmPassword} onChange={e => setChangePasswordConfirmPassword(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} placeholder="Confirm new password" />
              <button type="button" style={{ position: 'absolute', right: 8, top: 8, background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontWeight: 600 }} onClick={() => setShowConfirmPassword(v => !v)}>{showConfirmPassword ? "Hide" : "Show"}</button>
            </div>
            <button type="submit" disabled={isChangingPassword} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: isChangingPassword ? 'not-allowed' : 'pointer', opacity: isChangingPassword ? 0.7 : 1 }}>{isChangingPassword ? 'Updating...' : 'Change Password'}</button>
          </form>
        </div>
        <div style={{ color: '#888', fontSize: 14 }}>More settings coming soon.</div>
      </div>
    </div>
  );
}
